import TasksAPI from 'dashboard/api/tasks';
import { createStore } from 'dashboard/store/storeFactory';
import camelcaseKeys from 'camelcase-keys';

export const useTasksStore = createStore({
  name: 'tasks',
  type: 'pinia',
  API: TasksAPI,
  getters: {
    getTasksList: state => camelcaseKeys(state.records, { deep: true }),
  },
});
